import type { TextLayoutEvent } from 'react-native';

/**
 * A single-line `<Text>` is clipping when an un-clamped measuring copy of it (same width, no
 * `numberOfLines` cap) wraps to more than one line. Feed this the measuring copy's `onTextLayout`
 * event; pair it with the `common.measureLayer` style on that copy.
 */
export const isTextClipped = (e: TextLayoutEvent) => e.nativeEvent.lines.length > 1;
